module.exports = __webpack_public_path__ + "img/mIconRaster.92650d75.svg";